import React from 'react';
import classnames from 'classnames/bind';
import { noop } from 'lodash';
import { Spinner } from 'tuui';
import { OkOIcon } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components';
import { urlValidations } from 'modules/campaigns/config/validations/creative';
import { withIndication } from 'modules/errors/components/withIndication';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useUrlValidatedInput } from './useUrlValidatedInput';
import styles from './urlValidatedInput.module.scss';

const classNameBuilder = classnames.bind(styles);

const OutlineEditableTextWithIndication = withIndication(OutlineEditableText);

export const BYPASS_URL_RESPONSE_VALIDATION_FIELD = 'bypassUrlResponseValidation';

export const UrlValidatedInput = ({
    field = 'url',
    validations: validationsProp = urlValidations,
    validationDependencies: validationDependenciesProp,
    children,
    className,
    disabled,
    disabledPlaceholder,
    isResetFieldToInitialOnUnmount = false,
    onSubmitAnyway: onSubmitAnywayProp = noop,
    afterOnBlur,
    ...rest
}) => {
    const { cacheValue, onChange, onBlur, showSuccessIcon, isValidationsRunning, validationId, indicationData } =
        useUrlValidatedInput({
            field,
            validations: validationsProp,
            validationDependencies: validationDependenciesProp,
            isResetFieldToInitialOnUnmount,
            onSubmitAnyway: onSubmitAnywayProp,
            afterOnBlur,
            bypassField: BYPASS_URL_RESPONSE_VALIDATION_FIELD,
        });

    const { formatMessage } = useIntl();
    const placeholder = formatMessage({ id: 'creative.editor.content.url.placeholder', defaultMessage: 'Enter URL' });

    return (
        <OutlineEditableTextWithIndication
            id={validationId}
            value={disabled && disabledPlaceholder ? disabledPlaceholder : cacheValue}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            className={classNameBuilder('input', className)}
            data-metrics-event-name={GTM_EVENTS.USABILITY}
            data-metrics-component="URL"
            disabled={disabled}
            blurOnEnter
            {...indicationData}
            {...rest}
        >
            {!disabled && isValidationsRunning ? <Spinner size={16} className={styles['spinner']} /> : null}
            {!disabled && showSuccessIcon ? (
                <OkOIcon data-testid="okIcon" className={styles['success-icon']} aria-label="Validated url icon" />
            ) : null}
            {children}
        </OutlineEditableTextWithIndication>
    );
};
